import React from "react";
import { Button, CircularProgress, Stack, Typography } from "@mui/material";
import { GlobalContext } from "../../../context/GlobalContext";
import { TranslateContext } from "../../../context/TranslateContext";

function chargedAsLine(plan, settlement, lang) {
  if (!settlement || !plan?.id) return null;
  const usd = parseFloat(String(plan.price ?? "0")) || 0;
  const local = (usd * (Number(settlement.rate) || 1)).toFixed(2);
  return `${lang?.checkoutChargedAs || "Charged as"} ${settlement.symbol}${local} ${settlement.code}`;
}

const StripeComp = ({ plan, paying, setPaying, gwData }) => {
  const { hitAxios } = React.useContext(GlobalContext);
  const { lang } = React.useContext(TranslateContext);

  const isLoading = paying === "stripe";

  async function handleStripe() {
    setPaying("stripe");
    const res = await hitAxios({
      path: "/api/payment/stripe/create-session",
      admin: false,
      post: true,
      obj: { plan_id: plan.id },
    });
    if (res.data.success) {
      window.location.href = res.data.url;
    } else {
      setPaying("");
    }
  }

  return (
    <Stack spacing={0.5}>
      <Button
        fullWidth
        variant="outlined"
        size="large"
        disabled={!!paying}
        onClick={handleStripe}
        startIcon={
          isLoading ? (
            <CircularProgress size={18} color="inherit" />
          ) : (
            <span style={{ fontSize: "1.1rem" }}>💳</span>
          )
        }
        sx={{
          justifyContent: "flex-start",
          borderRadius: 2,
          fontWeight: 600,
          textTransform: "none",
          fontSize: "0.95rem",
          py: 1.2,
        }}
      >
        {isLoading
          ? lang?.redirecting || "Redirecting..."
          : lang?.payWith_stripe || "Pay with Stripe"}
      </Button>
      {gwData?.settlement ? (
        <Typography variant="caption" color="text.secondary" sx={{ pl: 0.5 }}>
          {chargedAsLine(plan, gwData.settlement, lang)}
        </Typography>
      ) : null}
    </Stack>
  );
};

export default StripeComp;
